export enum TwilioBusinessType {
  SoleProprietorship = "Sole Proprietorship",
  Partnership = "Partnership",
  LimitedLiabilityCorporation = "Limited Liability Corporation",
  CoOperative = "Co-operative",
  NonProfitCorporation = "Non-profit Corporation",
  Corporation = "Corporation",
}

export const TWILIO_VERIFICATION_CACHE_KEY = "agencyVerificationPending";
export const TWILIO_SHAKEN_STIR_CACHE_KEY = "agencyShakenStirPending";
export const TWILIO_ERROR_CACHE_KEY = "TwilioErrors";
